import React, { useState, useEffect } from 'react';

function ContactPageNew() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    projectType: 'Construction',
    message: '',
  });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    setErrorMsg('');

    const host = window.location.hostname;
    const isLocal = host === 'localhost' || host === '127.0.0.1';
    const apiUrl = isLocal
      ? `${window.location.origin}/contact.php`
      : (process.env.REACT_APP_API_URL || '/contact.php');

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok || !result.success) {
        throw new Error(result.debug || result.error || 'Unable to submit your inquiry. Please try again.');
      }

      setStatus('success');
      setFormData({ name: '', email: '', phone: '', projectType: 'Construction', message: '' });
      setTimeout(() => setStatus('idle'), 6000);
    } catch (error) {
      setErrorMsg(error.message || 'Unable to submit your inquiry. Please email us at ramainfrappl@yahoo.in.');
      setStatus('error');
    }
  };

  return (
    <div id="contact-page-view" className="view-section min-h-screen py-32 px-10 md:px-20 bg-black transition-all duration-500">
      <div className="max-w-7xl mx-auto">
        <div className="mb-20">
          <h2 className="bank-gothic text-xs tracking-[0.5em] text-neutral-500 mb-4 uppercase">Get In Touch</h2>
          <h3 className="bank-gothic text-4xl md:text-5xl">
            CONTACT <span className="accent-text">US</span>
          </h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          {/* Left Column: Company Details */}
          <div className="lg:col-span-5 space-y-12">
            <div>
              <h4 className="bank-gothic text-xs text-neutral-400 mb-4 uppercase tracking-[0.3em]">Company Information</h4>
              <div className="h-px bg-white/10 w-20 mb-8"></div>
              <div className="space-y-6 text-xs font-light text-neutral-300">
                <div>
                  <h5 className="bank-gothic text-white text-[10px] mb-2">COMPANY NAME</h5>
                  <p className="text-neutral-400">Rama Infra Projects</p>
                </div>
                <div>
                  <h5 className="bank-gothic text-white text-[10px] mb-2">ESTABLISHED</h5>
                  <p className="text-neutral-400">7th March 2000</p>
                </div>
              </div>
            </div>

            <div>
              <h4 className="bank-gothic text-xs text-neutral-400 mb-4 uppercase tracking-[0.3em]">Contact Details</h4>
              <div className="h-px bg-white/10 w-20 mb-8"></div>
              <ul className="space-y-4 text-xs font-light text-neutral-300">
                <li className="flex flex-col border-b border-white/5 pb-4">
                  <span className="bank-gothic text-[10px] text-neutral-500 mb-2">PHONE</span>
                  <span className="bank-gothic text-[11px] text-white">022-28943128</span>
                </li>
                <li className="flex flex-col border-b border-white/5 pb-4">
                  <span className="bank-gothic text-[10px] text-neutral-500 mb-2">EMAIL</span>
                  <span className="accent-text bank-gothic text-[11px]">ramainfrappl@yahoo.in</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div className="lg:col-span-7 bg-[#111] p-10 md:p-16 border border-white/5">
            <form onSubmit={handleSubmit} className="space-y-10" noValidate>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div className="flex flex-col">
                  <label className="bank-gothic text-[9px] text-neutral-500 mb-2">Your Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} required maxLength={100} className="input-underlined p-3 text-xs uppercase" placeholder="ENTER YOUR NAME" />
                </div>
                <div className="flex flex-col">
                  <label className="bank-gothic text-[9px] text-neutral-500 mb-2">Your Email</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} required maxLength={254} className="input-underlined p-3 text-xs" placeholder="your@email.com" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div className="flex flex-col">
                  <label className="bank-gothic text-[9px] text-neutral-500 mb-2">Phone Number</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} maxLength={30} className="input-underlined p-3 text-xs" placeholder="Your Contact Number" />
                </div>
                <div className="flex flex-col">
                  <label className="bank-gothic text-[9px] text-neutral-500 mb-2">Project Type</label>
                  <select name="projectType" value={formData.projectType} onChange={handleChange} className="input-underlined p-3 text-xs bg-[#111] text-neutral-400 uppercase">
                    <option>Construction</option>
                    <option>Interior Design</option>
                    <option>Utilities</option>
                    <option>Upgradation</option>
                    <option>Project Management</option>
                  </select>
                </div>
              </div>

              <div className="flex flex-col">
                <label className="bank-gothic text-[9px] text-neutral-500 mb-2">Message</label>
                <textarea name="message" value={formData.message} onChange={handleChange} rows="4" required maxLength={2000} className="input-underlined p-3 text-xs" placeholder="Tell us about your project requirements..."></textarea>
              </div>

              <div className="pt-6">
                <button type="submit" disabled={status === 'submitting'} className="btn-outline bank-gothic w-full text-center disabled:opacity-50 disabled:cursor-not-allowed">
                  {status === 'submitting' ? 'SENDING...' : 'SEND MESSAGE \u00a0 →'}
                </button>
              </div>
              {status === 'success' && (
                <div className="text-[10px] bank-gothic text-[#c49b66] text-center tracking-widest uppercase transition-all duration-300">
                  Thank you. Your inquiry has been submitted successfully.
                </div>
              )}
              {status === 'error' && (
                <div className="text-[10px] bank-gothic text-red-400 text-center tracking-widest uppercase transition-all duration-300">
                  {errorMsg}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPageNew;
